import { getAppVersion } from '@/lib/helpers/getAppVersion.ts'

export default function AppVersion() {
  const version = getAppVersion()
  if (!version) {
    return <></>
  }
  // Tiny muted line — diagnostic info, not a primary element. Left-aligned
  // and the same width as the identity row so it flows as a subtle footer.
  return (
    <span className={`block w-full truncate text-[10px] text-muted-foreground`}>{version}</span>
  )
}
